<template>
  <div class="statusClassCard" v-if="statusData&&statusData.length>0">
    <!-- 状态类型卡片 -->
    <div class="status-card-item" @click="toPath(item.url)" :class="`status-card-item${idx+1}`" :key="item.code" v-for="(item,idx) in statusData||[]">
      <div class="status-card-tb">
        <span v-if="idx==0"><img src="../../../assets/images/item_big.svg" alt=""></span>
        <span v-if="idx==1"><img src="../../../assets/images/order_big.svg" alt=""></span>
        <span v-if="idx==2"><img src="../../../assets/images/deliver_big.svg" alt=""></span>
      </div>
      <div class="status-card-info">
        <p class="status-card-p1">
          <span class="mr10"  v-if="idx==0"><img src="../../../assets/images/item_small.svg" alt=""></span>
          <span class="mr10"  v-if="idx==1"><img src="../../../assets/images/order_small.svg" alt=""></span>
          <span class="mr10"  v-if="idx==2"><img src="../../../assets/images/deliver_small.svg" alt=""></span>
          <span>{{item.name}}</span></p>
        <p class="status-card-p2">{{item.number}}</p>
      </div>
    </div>
    <!-- <div class="status-card-item status-card-item2">
      <div class="status-card-tb">
        <span><img src="../../../assets/images/order_big.svg" alt=""></span>
      </div>
      <div class="status-card-info">
        <p class="status-card-p1"><span class="mr10"><img src="../../../assets/images/order_small.svg" alt=""></span><span>所有订单</span></p>
        <p class="status-card-p2">8</p>
      </div>
    </div>
    <div class="status-card-item status-card-item3">
      <div class="status-card-tb">
        <span><img src="../../../assets/images/deliver_big.svg" alt=""></span>
      </div>
      <div class="status-card-info">
        <p class="status-card-p1"><span class="mr10"><img src="../../../assets/images/deliver_small.svg" alt=""></span><span>所有发货</span></p>
        <p class="status-card-p2">8</p>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  props: ['statusData'],
  data () {
    return {
    }
  },
  created () {
    
  },
  methods: {
    toPath (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style>
.statusClassCard{
  display: flex;

}
.statusClassCard .mr10{
  margin-right: 10px;
}
.statusClassCard .status-card-item{
  position: relative;
  width:32%;
  height:100px;
  border-radius: 5px;
  border-radius: 5px;
  color:#fff;
}
.statusClassCard .status-card-item:hover{
  cursor: pointer;
}
.statusClassCard .status-card-item .status-card-tb{
  position: absolute;
  right:0;
  bottom:0;
}
.statusClassCard .status-card-item:not(:last-child){
  margin-right: 15px;
}
.statusClassCard .status-card-item1{
  background-image: -ms-linear-gradient(-45deg, #5675FF 0%, #2FACFF 100%);
  background-image:  -moz-linear-gradient(-45deg, #5675FF 0%, #2FACFF 100%);
  background-image: -webkit-gradient(-45deg, #5675FF 0%, #2FACFF 100%);
  background-image: -webkit-linear-gradient(-45deg, #5675FF 0%, #2FACFF 100%);
  background-image: -o-linear-gradient(-45deg, #5675FF 0%, #2FACFF 100%);
  background-image: linear-gradient(-45deg, #5675FF 0%, #2FACFF 100%);
}
.statusClassCard .status-card-item2{
  background-image: -ms-linear-gradient(-48deg, #FF5D9D 0%, #FF7C53 100%);
  background-image:  -moz-linear-gradient(-48deg, #FF5D9D 0%, #FF7C53 100%);
  background-image: -webkit-gradient(-48deg, #FF5D9D 0%, #FF7C53 100%);
  background-image: -webkit-linear-gradient(-48deg, #FF5D9D 0%, #FF7C53 100%);
  background-image: -o-linear-gradient(-48deg, #FF5D9D 0%, #FF7C53 100%);
  background-image: linear-gradient(-48deg, #FF5D9D 0%, #FF7C53 100%);
}
.statusClassCard .status-card-item3{
  background-image: -ms-linear-gradient(-48deg, #00A1D5 0%, #00D3BF 100%);
  background-image:  -moz-linear-gradient(-48deg, #00A1D5 0%, #00D3BF 100%);
  background-image: -webkit-gradient(-48deg, #00A1D5 0%, #00D3BF 100%);
  background-image: -webkit-linear-gradient(-48deg, #00A1D5 0%, #00D3BF 100%);
  background-image: -o-linear-gradient(-48deg, #00A1D5 0%, #00D3BF 100%);
  background-image: linear-gradient(-48deg, #00A1D5 0%, #00D3BF 100%);
}
.statusClassCard .status-card-item .status-card-info{
  margin-left: 30px;
  margin-top: 20px;
  transition: all 0.5s;
}
.statusClassCard .status-card-item:hover .status-card-info{
  margin-left: 40px;
}
.statusClassCard .status-card-p1{
  opacity: 0.8;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 24px;
}
.statusClassCard .status-card-p2{
  font-size: 36px;
  color: #FFFFFF;
  line-height: 36px;
}
</style>


// WEBPACK FOOTER //
// src/pages/workBench/components/statusClassCard.vue